import React from 'react';

// Styles
import styles from "./../StaffManagment.module.css";

// Images
import arrowLeftBlack from "./../../../../assets/img/DashboardICons/ArrowLeftBlack.svg";
import pourcentStaffBG from "./../../../../assets/img/DashboardICons/pourcentStaffBG.svg";
import commissionStaffBG from "./../../../../assets/img/DashboardICons/commissionStaffBG.svg";
import assistanceStaffBG from "./../../../../assets/img/DashboardICons/assistanceStaffBG.svg";

const StaffManagmentHeadBoxs = (props) => {
    return (
        <div dir="rtl" className={`d-flex justify-content-between flex-wrap align-items-center mt-4 mx-4 px-2`}>
            <div className="w-100 d-flex justify-content-between align-items-center flex-wrap">
                <div style={{ backgroundColor: "#a3efc87d" }} className={`position-relative overflow-hidden d-flex justify-content-between align-items-center ${styles.total_staff_financial_head_box}`}>
                    <h3 className={`mb-0 ${styles.title_staff_financial_head_box}`}> درصد پورسانت </h3>
                    <img style={{ zIndex: 1 }} src={arrowLeftBlack} alt="arrow-left-black" role="button" onClick={() => props.setModalPourcentShow(true)} />
                    <img className={`position-absolute start-0 ${styles.image_BG_staff_financial_head_box}`} src={pourcentStaffBG} alt="pourcent-staff-BG" />
                </div>

                <div style={{ backgroundColor: "#E0E8FF" }} className={`position-relative overflow-hidden d-flex justify-content-between align-items-center ${styles.total_staff_financial_head_box}`}>
                    <h3 className={`mb-0 ${styles.title_staff_financial_head_box}`}> درصد کمیسیون </h3>
                    <img style={{ zIndex: 1 }} src={arrowLeftBlack} alt="arrow-left-black" role="button" onClick={() => props.setModalCommissionShow(true)} />
                    <img className={`position-absolute start-0 ${styles.image_BG_staff_financial_head_box}`} src={commissionStaffBG} alt="commission-staff-BG" />
                </div>

                <div style={{ backgroundColor: "#FFF9C0" }} className={`position-relative overflow-hidden d-flex justify-content-between align-items-center ${styles.total_staff_financial_head_box}`}>
                    <h3 className={`mb-0 ${styles.title_staff_financial_head_box}`}> مبلغ مساعده </h3>
                    <img style={{ zIndex: 1 }} src={arrowLeftBlack} alt="arrow-left-black" role="button" onClick={() => props.setModalAssistanceShow(true)} />
                    <img className={`position-absolute start-0 ${styles.image_BG_staff_financial_head_box}`} src={assistanceStaffBG} alt="assistance-staff-BG" />
                </div>
            </div>
        </div>
    )
}

export default StaffManagmentHeadBoxs;